/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'app/components/common/Modal.jsx';
import RecurlyModule from 'app/mixins/RecurlyModule.js';
import Loading from 'app/components/common/Loading.jsx';
import { Link } from 'react-router-dom';

class TDSChallengeModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            recurlyReady: false,
            recurlyConfigured: false,
            challengeInitiated: false,
            challengeError: ''
        };

        this.isRecurlyConfigured = this.isRecurlyConfigured.bind(this);

    }

    componentDidMount() {

        RecurlyModule.loadRecurly(this.props.app, (result) => {
            this.setState({
                recurlyReady: result
            });
            if (result) {
                RecurlyModule.generateRecurlyFields(this.props.app);
            }
            window.setTimeout(this.isRecurlyConfigured, 500);
        });

    }

    componentWillUnmount() {

        this.props.deleteApiError(['SUB_CREATE', 'SUB_UPDATE', 'SUB_UPDATE_BILLING']);

    }

    componentDidUpdate(prevProps, prevState) {
        let first = '',
            last = '',
            paymentInfo = this.state.paymentInfo,
            constants = this.props.app.config.constants;

        if (this.state.recurlyReady &&
            this.state.recurlyConfigured &&
            this.props.TDSChallenge !== '' &&
            !this.state.challengeInitiated)
        {
            const risk = recurly.Risk();
            const threeDS = risk.ThreeDSecure({actionTokenId: this.props.TDSChallenge});

            threeDS.on('error', err => {
                this.setState({
                    challengeError: err
                });
                threeDS.remove();
            });

            threeDS.on('token', token => {
                let data = Object.assign({}, this.props.requestData);
                data.three_d_secure_action_result_token_id = token.id;

                // clear out the last errors
                this.props.deleteApiError(['SUB_UPDATE', 'SUB_ADDON_UPDATE', 'SUB_CREATE']);

                // retry the last transaction with the 3ds token attached
                if (this.props.requestMethod) {
                    this.props.requestMethod.apply(this, [data]);
                }

                this.setState({
                    isSaving: true
                });

                threeDS.remove();
            });

            threeDS.attach(document.querySelector('#tds-challenge'));

            this.setState({
                challengeInitiated: true
            });

        }

    }

    isRecurlyConfigured() {
        if (!recurly.configured) {
            window.setTimeout(this.isRecurlyConfigured, 500);
        } else {
            this.setState({
                recurlyConfigured: true
            });
        }
    }

    render() {
        let constants = this.props.app.config.constants,
            content = null;

        // this is just a container for recurly to fill with the 3DS challenge
        content = (
            <div id="tds-challenge" className="tds-challenge"></div>
        );

        if (this.state.challengeError) {
            content = (
                <div id="tds-challenge" className="tds-challenge">
                    <div className="tds-error">{this.state.challengeError.message}</div>
                    <div className="tds-action">
                        <Link to="/account/billing?update=true" onClick={() => {
                                this.props.closeAllModals();
                            }}>Click here to change your payment method</Link>
                    </div>
                </div>
            );
        }

        if (this.state.isSaving) {
            content = (
                <div style={{height: "400px"}}>
                    <Loading/>
                </div>
            );
        }

        return (
            <Modal
                close={() => {
                    this.props.closeAllModals();
                }}
                headerContent="Your bank is requesting additional verification"
                content={content}/>
        );

    }

};

TDSChallengeModal.displayName = "TDSChallengeModal";

TDSChallengeModal.propTypes = {
    TDSChallenge: PropTypes.string
};

TDSChallengeModal.defaultProps = {
    TDSChallenge: ''
};

export default TDSChallengeModal;
